import { render } from "./LbrxDisplayBiatFirstTheme.vue?vue&type=template&id=059eee15&scoped=true"
import script from "./LbrxDisplayBiatFirstTheme.vue?vue&type=script&lang=js"
export * from "./LbrxDisplayBiatFirstTheme.vue?vue&type=script&lang=js"

import "./LbrxDisplayBiatFirstTheme.vue?vue&type=style&index=0&id=059eee15&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-059eee15"]])

export default __exports__